var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitoringhubLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 50,
    viewBox: "0 0 559.981 292.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.27,
    x2: 0.5,
    y2: 1.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1850a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.044,
    y1: 1.051,
    x2: 0.179,
    y2: 0.047,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.009,
    y1: 1.011,
    x2: 0.773,
    y2: 0.103,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-145.817 -271.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M244.069,436.978a43.9,43.9,0,0,1,0-62.086l90.881-90.883a43.9,43.9,0,0,1,62.087,0L425.2,312.17l28.161-28.16a43.9,43.9,0,0,1,62.087,0l90.881,90.883a43.9,43.9,0,0,1,0,62.086l-25.178,25.179a43.9,43.9,0,0,1-62.086,0l-31.41-31.41-31.41,31.41a43.9,43.9,0,0,1-62.087,0l-31.41-31.41-31.41,31.41a43.9,43.9,0,0,1-62.086,0Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M487.651,430.746l56.222-56.22a43.9,43.9,0,0,1,62.085,0l.367.367a43.9,43.9,0,0,1,0,62.086l-25.178,25.179a43.9,43.9,0,0,1-62.086,0Z",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M362.744,430.746l-56.222-56.22a43.9,43.9,0,0,0-62.086,0l-.367.367a43.9,43.9,0,0,0,0,62.086l25.179,25.179a43.9,43.9,0,0,0,62.086,0Z",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M167.983,562.487l-10.438-33.72v33.72H145.817V511.593h17.035l9.669,31.207,9.7-31.207h17.1v50.894H187.461v-33.72l-10.646,33.72Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M205.124,536.533A26.654,26.654,0,0,1,216.992,514.7a26.077,26.077,0,0,1,14.487-4.087,24.967,24.967,0,0,1,18.606,7.685,26.962,26.962,0,0,1,.384,36.921,26.338,26.338,0,0,1-37.752.4A26.269,26.269,0,0,1,205.124,536.533Zm12.881.14a14.305,14.305,0,0,0,3.77,9.752,12.587,12.587,0,0,0,18.5.873,14.664,14.664,0,0,0,.663-20.028,12.59,12.59,0,0,0-9.6-3.844,13.742,13.742,0,0,0-8.656,2.832Q218,529.856,218.005,536.673Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M295.011,562.487l-19.024-28.345v28.345H263.594V511.593H274.9l18.605,28.274V511.593h12.356v50.894Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M314.034,511.593h12.393v50.894H314.034Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M362.311,523.356h-9.565v39.131H340.284V523.356h-9.529V511.593h31.556Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M363.813,536.533A26.654,26.654,0,0,1,375.681,514.7a26.076,26.076,0,0,1,14.486-4.087,24.967,24.967,0,0,1,18.607,7.685,26.961,26.961,0,0,1,.383,36.921,26.338,26.338,0,0,1-37.752.4A26.268,26.268,0,0,1,363.813,536.533Zm12.881.14a14.3,14.3,0,0,0,3.769,9.752,12.587,12.587,0,0,0,18.5.873,14.665,14.665,0,0,0,.663-20.028,12.589,12.589,0,0,0-9.6-3.844,13.745,13.745,0,0,0-8.657,2.832Q376.693,529.856,376.694,536.673Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M444.448,562.487l-9.773-16.371v16.371H422.282V511.593h16.9q7.749,0,12.5,2.618a13.167,13.167,0,0,1,5.865,6.352,19.67,19.67,0,0,1,1.466,7.924,16.285,16.285,0,0,1-11.624,16.686l12.462,17.314ZM434.675,522.9v12.183q6.527,0,8.971-1.222,2.688-1.326,2.687-4.922,0-3.351-1.885-4.538Q442.04,522.9,434.675,522.9Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M465.567,511.593h12.392v50.894H465.567Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M517.509,562.487l-19.024-28.345v28.345H486.092V511.593H497.4l18.6,28.274V511.593h12.356v50.894Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M557.2,544.021V533.863h29.079q0,14.279-7.226,22.131-6.912,7.506-18.78,7.506a26.1,26.1,0,0,1-26.181-26.356A26.456,26.456,0,0,1,541,518.888a24.315,24.315,0,0,1,18.919-8.273,25.966,25.966,0,0,1,15.743,5.062,35.165,35.165,0,0,1,4.015,3.595,27.35,27.35,0,0,1,2.514,3.386,29.154,29.154,0,0,1,2.652,5.481h-14.1a22.734,22.734,0,0,0-5.061-3.6,12.456,12.456,0,0,0-5.306-1.257,13.427,13.427,0,0,0-8.936,3.281,12.53,12.53,0,0,0-4.468,10.089,13.857,13.857,0,0,0,4.084,10.157,12.785,12.785,0,0,0,9.391,4.015,11.822,11.822,0,0,0,5.479-1.291,15.5,15.5,0,0,0,5.795-5.516Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M622.2,539.308H597.865v23.179H592.77V511.593h5.095v22.759H622.2V511.593h4.852v50.894H622.2Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M663.212,511.593h5.1v32.289q0,9.6-3.561,14.346Q660.8,563.5,652.041,563.5a20.6,20.6,0,0,1-7.261-1.082,12.094,12.094,0,0,1-6.352-5.481q-2.689-4.713-2.689-13.055V511.593h4.993v30.648a24.432,24.432,0,0,0,1.78,10.228,9.63,9.63,0,0,0,4.363,4.677,11.721,11.721,0,0,0,5.306,1.118q5.479,0,8.134-3.561,2.895-3.875,2.9-12.462Z",
    fill: "#00509d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M688.1,562.487H676.861V511.593h10.821q7.121,0,11.292,3.68a13.889,13.889,0,0,1,2.74,16.068,11.4,11.4,0,0,1-3.735,3.733,12.121,12.121,0,0,1,5.759,4.523,12.832,12.832,0,0,1,2.06,7.35q0,7.02-3.665,10.9Q697.734,562.487,688.1,562.487Zm-6.388-46.077v17.174h2.857q7,0,10-1.78,3.413-2.025,3.413-7.157,0-4.223-2.822-6.143-3.066-2.1-10.031-2.094h-3.414Zm0,21.852v19.373q11.672,0,15.052-1.538,4.008-1.818,4.008-8.149,0-4.406-2.265-6.574-2.057-1.959-6.551-2.622A77.136,77.136,0,0,0,681.712,538.262Z",
    fill: "#00509d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringhubLogo);
export default __webpack_public_path__ + "static/media/monitoringhub-logo.fb4a6f25b53cec9eb4bc7c765a5be363.svg";
export { ForwardRef as ReactComponent };